import z from 'zod';
import {userAccountSchema} from "./userAccountSchemas";

const userAccountDetailsSchema = userAccountSchema.extend({
    registeredBoatIds: z.array(z.number()),
    createdRaceIds: z.array(z.number()),
    organizedRaceIds: z.array(z.number()),
});

type UserAccountDetails = z.infer<typeof userAccountDetailsSchema>;

export {userAccountDetailsSchema, type UserAccountDetails};